import React, { useCallback, useEffect, useRef, useState } from "react";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeaderForTeenPatti";
import TpStudioHeader from "../../client/tp-studio/tp-studio-header";
import TPStudioSidebar from "../../client/tp-studio/TPStudioSidebar";
import "../../../assets/topstudio/styles/CardsSprite.css";
import "../../../assets/topstudio/styles/roulet.css";
import GameTimer from "./components/GameTimer";
import chip1 from "../../../assets/topstudio/images/dreamcatcher/chip1.svg";
import chip2 from "../../../assets/topstudio/images/dreamcatcher/chip2.svg";
import chip3 from "../../../assets/topstudio/images/dreamcatcher/chip3.svg";
import chip4 from "../../../assets/topstudio/images/dreamcatcher/chip4.svg";
import axiosInstance from "../../../utils/axiosInstance";
import rouletBg from "../../../assets/topstudio/images/dreamcatcher/RouletteBg.webp";
import rouletPin from "../../../assets/topstudio/images/dreamcatcher/RoulettePin.svg";
import roulet from "../../../assets/topstudio/images/dreamcatcher/Dreamcatcher.png";
import undoIcon from "../../../assets/topstudio/images/rolet/undo-icon.svg";
import resetIcon from "../../../assets/topstudio/images/rolet/reset-icon.svg";
import reconnecting from "../../../assets/topstudio/images/rolet/reconnecting.gif";
import BgSound from "../../../assets/topstudio/audio/TpbgSound.mp3";
import useSocket from "../../../hooks/useSocket";
import "../../../assets/topstudio/styles/dreamcatcher.css";
//import Teenpattit20Result from "../../client/tp-studio/tp-result/Teenpattit20-Result.jsx";
import DreamCatcherResult from "./tp-result/DreamcatcherResult.jsx";
import TpStudioLoader from "../../client/tp-studio/tp-studio-loader";
import DreamRules from "./pop-up/dreamc-rules.jsx";

import { useDispatch, useSelector } from "react-redux";
import { setUserData } from "../../../store/userSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Check, X } from "lucide-react";

/*.overlayRoulettelock {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
}
*, */

const DC_WHEEL_ORDER = [
  1, 20, 1, 2, 1, "7x", 1, 10, 2, 1, 5, 2, 1, 2, 1, 2, 1, 5,
  40, 1, 10, 1, 2, 1, 5, 2, 1, 20, 1, 2, 1, "2x", 1, 10, 2, 1,
  5, 2, 1, 2, 1, 2, 1, 5, 40, 1, 10, 1, 2, 1, 5, 2,
];

const DC_SLOT_DEG = 360 / DC_WHEEL_ORDER.length;

const DC_VALID_RESULTS = [1, 2, 5, 10, 20, 40];

const DC_MULTIPLIERS = { b1: 1, b2: 2, b3: 5, b4: 10, b5: 20, b6: 40 };

function showDreamCatcherToast(message, variant) {
  const isError = variant === "error";
  toast.dismiss("dc-order-toast");
  toast(
    <div className="av-toast-body">
      <span className="av-toast-icon">
        {isError ? (
          <X size={24} color="#ffffff" strokeWidth={3} aria-hidden="true" />
        ) : (
          <Check size={24} color="#ffffff" strokeWidth={3} aria-hidden="true" />
        )}
      </span>
      <span className="av-toast-text">{message}</span>
    </div>,
    {
      toastId: "dc-order-toast",
      className: isError ? "av-lost-toast" : "av-bet-toast",
      icon: false,
      closeButton: false,
      autoClose: variant === "submitting" ? false : 1500,
      hideProgressBar: false,
      position: "top-center"
    }
  );
}

function hasConcreteDCPayload(raw) {
  if (raw === undefined || raw === null) return false;
  if (raw === "") return false;
  if (typeof raw === "string" && raw.trim() === "") return false;
  if (typeof raw === "object" && !Array.isArray(raw) && Object.keys(raw).length === 0) return false;
  if (Array.isArray(raw) && raw.length === 0) return false;
  return true;
}

function extractDCResultNumber(payloadResult) {
  if (payloadResult == null || payloadResult === "") return null;
  if (typeof payloadResult === "number" && Number.isFinite(payloadResult)) return payloadResult;
  if (typeof payloadResult === "string") {
    const t = payloadResult.trim();
    if (t === "") return null;
    const n = Number(t);
    return Number.isNaN(n) ? null : n;
  }
  if (Array.isArray(payloadResult)) {
    if (payloadResult.length === 0) return null;
    const fromLast = extractDCResultNumber(payloadResult[payloadResult.length - 1]);
    if (fromLast !== null) return fromLast;
    return extractDCResultNumber(payloadResult[0]);
  }
  if (typeof payloadResult === "object") {
    const vals = Object.values(payloadResult);
    if (vals.length === 0) return null;
    const fromLast = extractDCResultNumber(vals[vals.length - 1]);
    if (fromLast !== null) return fromLast;
    return extractDCResultNumber(vals[0]);
  }
  return null;
}

export default function DreamCatcher() {
  const dispatch = useDispatch();

  const [showRules, setShowRules] = useState(false);
  const [open, setOpen] = useState(false);
  const [betAmount, setBetAmount] = useState(100);
  const [resultList, setResultList] = useState([]);
  const [roundId, setRoundId] = useState("");
  const [resultData, setResultData] = useState([]);
  const [socketResult, setSocketResult] = useState({});

  const { data } = useSocket({
    marketId: null,
    mtype: "teenpatti",
    type: "dream_catcher"
  });
  //console.log("SOCKET DATA:", data);

  const payload = data?.data?.data;
  const payloadResult = data?.data?.result;

  const heldResultRef = useRef(null);
  const rawResult = data?.data?.data?.result;
  if (
    rawResult !== undefined &&
    rawResult !== null &&
    rawResult !== "" &&
    !(typeof rawResult === "string" && rawResult.trim() === "") &&
    !(
      typeof rawResult === "object" &&
      !Array.isArray(rawResult) &&
      Object.keys(rawResult).length === 0
    )
  ) {
    heldResultRef.current = rawResult;
  }
  const payloadResultForSpin = heldResultRef.current;

  const [placedBets, setPlacedBets] = useState([]);
  const [displayLoader, setDisplayLoader] = useState(true);
  const displayRunnerName = (runnerName) => {
    return runnerName + " - " + oddsData?.evt_id;
  };

  async function getPlacedBets() {
    if (!oddsData?.evt_id) return;
    const placedBets = await axiosInstance.post("/casino/get-placed-bets", {
      cat_mid: oddsData.evt_id,
      gametype: "dream_catcher"
    });

    setPlacedBets(placedBets.data);
  }
  const [oddsData, setOddsData] = useState(null);

  const updateUserData = async (userData) => {
    if (!userData || !sessionUser) return;
    await dispatch(
      setUserData({
        ...sessionUser,
        fname: userData.fname ?? sessionUser.fname,
        uname: userData.uname ?? sessionUser.uname,
        bz_balance: userData.bz_balance ?? sessionUser.bz_balance,
        opin_bal: userData.opin_bal ?? sessionUser.opin_bal,
        user_role: sessionUser.user_role,
        _id: sessionUser._id
      })
    );
  };

  useEffect(() => {
    if (!payload) return;

    updateUserData(data?.user);

    setDisplayLoader(false);
    setOddsData(payload);
    setRoundId(payload.evt_id);
  }, [payload]);

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      setResultList([]);
      setResultList(payloadResult);
      setSocketResult(payloadResult);

      setResultData(payloadResult);
    }
  }, [payloadResult]);

  /** ---------------- BET STATE ---------------- */
  const [betHistory, setBetHistory] = useState([]);

  const [b1Amt, setB1Amt] = useState(0);
  const [b2Amt, setB2Amt] = useState(0);
  const [b3Amt, setB3Amt] = useState(0);
  const [b4Amt, setB4Amt] = useState(0);
  const [b5Amt, setB5Amt] = useState(0);
  const [b6Amt, setB6Amt] = useState(0);

  const [activeTabIndex, setActiveTabIndex] = useState(1);
  const [soundEnabled, setSoundEnabled] = useState(false);

  const bgAudioRef = useRef(null);

  const BET_META = {
    b1: { odds: 1, teamname: 1 },
    b2: { odds: 2, teamname: 2 },
    b3: { odds: 5, teamname: 5 },
    b4: { odds: 10, teamname: 10 },
    b5: { odds: 20, teamname: 20 },
    b6: { odds: 40, teamname: 40 }
  };

  const addToBet = (betType) => {
    if (!oddsData?.evt_id || oddsData?.evt_status !== "OPEN") return;

    const meta = BET_META[betType];
    if (!meta) return;

    setBetHistory((prev) => {
      const existingIndex = prev.findIndex(
        (b) => b.betType === betType && b.catmid === oddsData.evt_id
      );

      if (existingIndex !== -1) {
        return prev.map((b, i) =>
          i === existingIndex
            ? { ...b, amount: Number(b.amount) + Number(betAmount) }
            : b
        );
      }

      return [
        ...prev,
        {
          betType,
          amount: betAmount,
          odds: meta.odds,
          teamname: meta.teamname,
          catmid: oddsData.evt_id
        }
      ];
    });
  };

  const activeTab = async (tab1) => {
    setActiveTabIndex(tab1);
    if (tab1 == 2) {
      //showResultDetail();
    }
  };

  const playBGSoundWithRetry = () => {
    const audio = bgAudioRef.current;
    if (!audio) return;
    audio.play().catch(() => {
      setTimeout(() => audio.play().catch(() => {}), 250);
    });
  };

  const toggleSound = (e) => {
    const on = e.target.checked;
    setSoundEnabled(on);
    if (on) {
      playBGSoundWithRetry();
    } else {
      bgAudioRef.current?.pause();
    }
  };

  useEffect(() => {
    let t1 = 0,
      t2 = 0,
      t3 = 0,
      t4 = 0,
      t5 = 0,
      t6 = 0;

    betHistory.forEach((bet) => {
      if (bet.catmid !== oddsData?.evt_id) return;

      switch (bet.odds) {
        case 1:
          t1 += Number(bet.amount);
          break;
        case 2:
          t2 += Number(bet.amount);
          break;
        case 5:
          t3 += Number(bet.amount);
          break;
        case 10:
          t4 += Number(bet.amount);
          break;
        case 20:
          t5 += Number(bet.amount);
          break;
        case 40:
          t6 += Number(bet.amount);
          break;
        default:
          break;
      }
    });

    setB1Amt(t1);
    setB2Amt(t2);
    setB3Amt(t3);
    setB4Amt(t4);
    setB5Amt(t5);
    setB6Amt(t6);
  }, [betHistory, oddsData?.evt_id]);

  const undoLastBet = () => {
    if (oddsData?.evt_status !== "OPEN") return;
    setBetHistory((prev) => prev.slice(0, -1));
  };

  const resetBets = () => {
    if (oddsData?.evt_status !== "OPEN") return;
    setBetHistory([]);
  };

  const betSubmittedRef = useRef(false);

  const submitBid = async () => {
    if (betSubmittedRef.current) return;
    if (!oddsData?.evt_id) return;
    if (betHistory.length === 0) return;

    betSubmittedRef.current = true;

    const payload = {
      catmid: oddsData.evt_id,
      game_name: "dream_catcher",
      market_type: "m",
      betPlaceArr: betHistory.map((bet) => ({
        amount: bet.amount,
        catmid: bet.catmid,
        market_type: "m",
        game_type: 7,
        game_name: "dream_catcher",
        odds: bet.odds,
        teamname: bet.teamname,
        bettype: "b"
      }))
    };

    showDreamCatcherToast("Submitting order", "submitting");

    try {
      const response = await axiosInstance.post(
        "/casino/place-bet-casino-multiple",
        payload
      );

      if (response.data?.status) {
        showDreamCatcherToast("order placed successfully", "success");
        getPlacedBets();
      } else {
        betSubmittedRef.current = false;
        showDreamCatcherToast(
          response.data?.message || "Bet not placed",
          "error"
        );
      }
    } catch (err) {
      betSubmittedRef.current = false;
      showDreamCatcherToast(
        err?.response?.data?.message || "Bet not placed",
        "error"
      );
    }
  };

  const showResultDetail = async () => {
    let resultObj = {};
    resultObj.game_type = "dream_catcher";

    //console.log("BEFORE API CALL");

    const response = await axiosInstance.post("/teenpatti-results", resultObj);

    //console.log("FULL RESPONSE", response.data);
    //console.log("AFTER API CALL");
    setResultData(response.data.results_list);

    //console.log("response->", resultData);
    //console.log(response.data.results_list);
    //console.log(response.data.results_list[0]);
    //console.log("First Result:", response.data.results_list[0].result);
  };

  const [phase, setPhase] = useState("idle");
  const [count, setCount] = useState(0);
  const [rotation, setRotation] = useState(0);
  const [resultOverlay, setResultOverlay] = useState(null);

  const [stopBetting, setStopBetting] = useState(false);
  const prevRotationRef = useRef(0);

  const lastRoundIdRef = useRef(null);
  const spinResultLockRef = useRef(null);
  const pendingWinnerRef = useRef(null);
  const winnerDelayRef = useRef(null);
  const sessionUser = useSelector((s) => s.userStore.data);

  const spinDurationMs = 6000;

  const spinWheel = useCallback((winningNumber) => {
    const extraTurns = 5;
    let deltaDeg;

    if (winningNumber !== undefined && winningNumber !== null) {
      const n = Number(winningNumber);
      if (!Number.isNaN(n) && DC_VALID_RESULTS.includes(n)) {
        const allIndices = DC_WHEEL_ORDER.reduce(
          (acc, v, i) => (v === n ? [...acc, i] : acc),
          []
        );
        const idx = allIndices[Math.floor(Math.random() * allIndices.length)];
        if (idx >= 0) {
          const targetDegrees = idx * DC_SLOT_DEG;
          const currentRotationMod =
            ((prevRotationRef.current % 360) + 360) % 360;
          deltaDeg =
            (((360 - targetDegrees - currentRotationMod) % 360) + 360) % 360;
        }
      }
    }

    if (deltaDeg === undefined) return;

    const target = prevRotationRef.current + extraTurns * 360 + deltaDeg;

    if (winnerDelayRef.current) {
      clearTimeout(winnerDelayRef.current);
      winnerDelayRef.current = null;
    }
    pendingWinnerRef.current = Number(winningNumber);
    setResultOverlay(null);
    setPhase("spinning");
    setRotation(target);
    prevRotationRef.current = target;
  }, []);

  const handleWheelStopped = (event) => {
    if (event.propertyName !== "transform") return;
    if (event.target !== event.currentTarget) return;
    const winningNumber = pendingWinnerRef.current;
    if (winningNumber == null) return;
    pendingWinnerRef.current = null;
    setPhase("stopped");
    setResultOverlay({ stage: "winner", number: winningNumber });
  };

  useEffect(() => {
    if (!resultOverlay) return undefined;

    if (resultOverlay.stage === "winner") {
      const timer = setTimeout(() => {
        setResultOverlay({
          stage: "next",
          number: resultOverlay.number,
          seconds: 3
        });
      }, 4000);
      return () => clearTimeout(timer);
    }

    if (resultOverlay.seconds <= 1) {
      const timer = setTimeout(() => setResultOverlay(null), 1000);
      return () => clearTimeout(timer);
    }

    const timer = setTimeout(() => {
      setResultOverlay((prev) =>
        prev && prev.stage === "next"
          ? { ...prev, seconds: prev.seconds - 1 }
          : prev
      );
    }, 1000);
    return () => clearTimeout(timer);
  }, [resultOverlay]);

  const prevLeftTimeRef = useRef(null);

  useEffect(() => {
    if (!oddsData) return;

    const { evt_id, left_time, evt_status } = oddsData;

    if (lastRoundIdRef.current !== evt_id) {
      lastRoundIdRef.current = evt_id;
      betSubmittedRef.current = false;
      prevLeftTimeRef.current = null;
      setBetHistory([]);
      setPlacedBets([]);
    }

    if (evt_status === "OPEN" && left_time > 0) {
      setPhase((current) => (current === "spinning" ? current : "countdown"));
      setCount(left_time);
    }

    if (left_time <= 11) {
      setStopBetting(true);
    } else {
      setStopBetting(false);
    }

    if (
      evt_status === "OPEN" &&
      prevLeftTimeRef.current > 11 &&
      left_time <= 11 &&
      betHistory.length > 0
    ) {
      submitBid();
    }

    prevLeftTimeRef.current = left_time;
  }, [oddsData, betHistory]);

  useEffect(() => {
    const evtId = oddsData?.evt_id;
    const n = extractDCResultNumber(oddsData?.result);
    if (evtId == null || evtId === "") return;
    if (n === null || !DC_VALID_RESULTS.includes(n)) return;

    const lockKey = `${evtId}|${n}`;
    if (spinResultLockRef.current === lockKey) return;

    const left = Number(oddsData?.left_time);
    // The clock label shows 0 once a second is left. Keep the wheel still until then.
    if (Number.isFinite(left) && left > 1) return;

    spinResultLockRef.current = lockKey;
    spinWheel(n);
  }, [oddsData?.evt_id, oddsData?.result, oddsData?.left_time, spinWheel]);

  useEffect(() => {
    return () => {
      if (winnerDelayRef.current) clearTimeout(winnerDelayRef.current);
    };
  }, []);

  useEffect(() => {
    if (phase !== "countdown") return;
    if (count <= 0) return;

    const t = setTimeout(() => setCount((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [phase, count]);

  useEffect(() => {
    document.documentElement.classList.add("roulette-bg-black");
    document.documentElement.classList.add("h-100");
    document.documentElement.classList.add("dreamcatcher-route-scroll");

    return () => {
      document.documentElement.classList.remove("roulette-bg-black");
      document.documentElement.classList.remove("h-100");
      document.documentElement.classList.remove("dreamcatcher-route-scroll");
    };
  }, []);
  function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const onResize = () => setIsMobile(window.innerWidth <= breakpoint);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);

    return isMobile;
  }
  const isMobile = useIsMobile();
  return (
    <>
      <div className="dreamcatcher-scope roulette-bg-black">
        <ClientLayoutWithOutHeader showLoader={false}>
          <style>
            {`
            .dreamcatcher-scope {
              width: 100%;
              max-width: 100%;
              overflow-x: hidden;
              box-sizing: border-box;
            }
            .dreamcatcher-scope .details-tabs-wrapper1,
            .dreamcatcher-scope .main-page,
            .dreamcatcher-scope .bodyheight,
            .dreamcatcher-scope .card-body {
              max-width: 100%;
              box-sizing: border-box;
            }
            .dreamcatcher-scope .roulette-bgNew {
              overflow: hidden;
            }
            .dreamcatcher-scope .roulette-wheel {
              width: 80%;
              max-width: 312px;
              height: auto;
            }
            .dreamcatcher-scope .roulette-pin {
              width: 4.8%;
            }
            .dreamcatcher-scope .roulli-wheel-DC {
              margin-top: -35px;
            }
            @media (max-width: 770px) {
              .dreamcatcher-scope .roulette-wheel {
                width: 80%;
                max-width: 312px;
                height: auto;
              }
            }
            @media (max-width: 480px) {
              .dreamcatcher-scope .roulette-pin {
                width: 7.68%;
              }
              .dreamcatcher-scope .roulli-wheel-DC {
                margin-top: -65px;
              }
            }
            .dreamcatcher-scope .overlayaviator {
              backdrop-filter: blur(8px);
              -webkit-backdrop-filter: blur(8px);
              background: rgba(0, 0, 0, 0.28);
            }
            .dreamcatcher-scope .overlay-textaviator {
              font-size: 40px;
              font-weight: 700;
              color: #fff;
              text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
            }
            html.dreamcatcher-route-scroll,
            html.dreamcatcher-route-scroll body,
            html.dreamcatcher-route-scroll #root {
              width: 100%;
              max-width: 100%;
              overflow-x: hidden;
              box-sizing: border-box;
            }

            .player-scope .table-player .player {
              width: 210px !important;
            }
            .player-scope .table-player {
              gap: 9px !important;
              align-items: center;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              height: auto !important;
              min-height: auto !important;
            }
            .player-scope .table-player .player-dt {
              display: flex !important;
              flex-direction: column;
              align-items: center !important;
              max-width: none;
              width: auto;
              color: #d7bc7b !important;
              font-size: 12px;
              font-weight: 700;
            }
            @media (min-width:992px){
              .cards-layout.blackjack {
                min-height: 240px;
              }
              .volume-wrapper {
                margin-top: -30px;
              }
            }  
            /* mobile */  
            @media (max-width: 576px) {
              .cards-layout.blackjack {
                min-height: 120px !important;
                width: 100% !important;
                padding: 0 !important;
              }
              .scroll-containeraviator img {
                width: 100% !important;
                height: auto !important;
                display: block;
              }
              .row {
                margin-left: 0 !important;
                margin-right: 0 !important;
              }
              .col-1,
              .col-6,
              .col-md-8,
              .col-md-6 {
                padding-left: 0 !important;
                padding-right: 0 !important;
              }
              .card-body {
                padding-left: 5px !important;
                padding-right: 5px !important;
              }
              .no-padding-mobile {
                padding-left: 0 !important;
                padding-right: 0 !important;
              }
              .wheel-margin{
                margin-top: -90px;
              }
 
            }         
          `}
          </style>
          <div class="details-tabs-wrapper1">
            <div className="main-page">
              <div className="row no-gutters">
                <div className="col-md-12">
                  <div className="bodyheight">
                    <div className="wrapper">
                      <TPStudioSidebar open={open} />
                    </div>

                    <div className="lobby-ctn BPGmaindiv">
                      <TpStudioHeader setOpen={setOpen} open={open} />
                      <TpStudioLoader displayLoader={displayLoader} />
                    </div>

                    <div className="card-body" style={{ padding: "0" }}>
                      {/* Keep BOTH columns inside this ONE row */}
                      <div
                        className="row"
                        style={{
                          padding: "0",
                          margin: 0,
                          display: displayLoader ? "none" : ""
                        }}
                      >
                        {/* LEFT COLUMN */}
                        <div
                          className="col-md-8"
                          style={{ paddingLeft: "30px" }}
                        >
                          <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer h-45">
                            <div className="col-6 col-md-6 titlebarname  inline-block Gameidcol mt-2">
                              <p>&nbsp;DREAM CATCHER</p>
                            </div>
                            <div
                              className="col-6 col-md-6 inline-block Gameidcol text-right"
                              style={{ marginTop: "4px" }}
                            >
                              <div
                                role="group"
                                aria-label="Second group"
                                className="btn-group btn-group-sm mr-2"
                              >
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="Alltab"
                                  className={
                                    activeTabIndex == 1
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(1)}
                                >
                                  Game
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  id="RESULTStab"
                                  className={
                                    activeTabIndex == 2
                                      ? "tablink btn btn-primary bbactive"
                                      : "tablink btn btn-primary"
                                  }
                                  onClick={() => activeTab(2)}
                                >
                                  Results
                                </button>
                                <button
                                  style={{ fontSize: "14px" }}
                                  type="button"
                                  className="tablink btn btn-primary"
                                  onClick={() => setShowRules(true)}
                                >
                                  Rules
                                </button>
                                <DreamRules
                                  show={showRules}
                                  onClose={() => setShowRules(false)}
                                />
                              </div>
                            </div>
                          </div>
                          {/* Header / Timer */}
                          <div
                            className="row"
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div className="col-2 col-md-1">
                              <div className="Connectedclients mt-1">
                                <i
                                  aria-hidden="true"
                                  className="fa fa-user mr-1"
                                  style={{
                                    fontSize: "14px",
                                    color: "white"
                                  }}
                                />
                                <b>
                                  <span id="UsersCount" className="number">
                                    52
                                  </span>
                                </b>
                              </div>
                            </div>
                          </div>
                          <div
                            className="cards-layout position-relative"
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div
                              className="overlayaviator"
                              style={{
                                display: resultOverlay ? "flex" : "none"
                              }}
                            >
                              <span className="overlay-textaviator">
                                <b>
                                  {resultOverlay?.stage === "winner"
                                    ? `Winner is ${resultOverlay.number}`
                                    : resultOverlay?.stage === "next"
                                      ? `Starting in ${resultOverlay.seconds}`
                                      : ""}
                                </b>
                              </span>
                            </div>

                            <div
                              className="cards-layout font-familyAVE roulette-bgNew"
                              style={{
                                backgroundImage: `url(${rouletBg})`,
                                backgroundRepeat: "round"
                              }}
                            >
                              <audio ref={bgAudioRef} src={BgSound} loop />

                              <div className="col-12 timerDiv2 pb-4">
                                <GameTimer leftTime={oddsData?.left_time} />
                              </div>

                              {/* Roulette Main Section */}
                              <div
                                className="cards-layout wheel-margin"
                                style={{ position: "relative" }}
                              >
                                <div className="roulli-wheel-DC">
                                  <img
                                    src={rouletPin}
                                    alt="PIN"
                                    className="roulette-pin"
                                  />
                                  <img
                                    id="rouletteWheel"
                                    src={roulet}
                                    alt="roulette"
                                    className="roulette-wheel"
                                    onTransitionEnd={handleWheelStopped}
                                    style={{
                                      transform: `rotate(${rotation}deg)`,
                                      transition:
                                        phase === "spinning"
                                          ? `transform ${spinDurationMs}ms cubic-bezier(0.1, 0.7, 0.2, 1)`
                                          : "none"
                                    }}
                                  />
                                </div>

                                <label
                                  htmlFor="AvxSoundcontrol"
                                  className={`fa fa-inverse sound-icon ${
                                    soundEnabled
                                      ? "fa-volume-up"
                                      : "fa-volume-off"
                                  }`}
                                  style={{
                                    position: "absolute",
                                    right: 18,
                                    bottom: -1,
                                    zIndex: 100,
                                    cursor: "pointer",
                                    width: 15,
                                    height: 15,
                                    fontSize: 15,
                                    lineHeight: "15px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginTop: 12
                                  }}
                                  title="Toggle sound"
                                >
                                  <input
                                    id="AvxSoundcontrol"
                                    type="checkbox"
                                    checked={soundEnabled}
                                    onChange={toggleSound}
                                    style={{ display: "none" }}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>

                          {/* Last 10 results + round id */}
                          <center
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div className="footer-divbpg border-gradient-footer border-gradient-purple-footer">
                              <div className="buttons-div">
                                {Object.keys(resultList)
                                  .slice(-10)
                                  .map((idx) => (
                                    <button className="video-button border-gradient-btn border-gradient-purple-btn col-Black">
                                      {resultList[idx]}
                                    </button>
                                  ))}
                              </div>
                              <div className="round-div">
                                <div className="label">Round ID:</div>
                                <div className="id">{roundId}</div>
                              </div>
                            </div>
                          </center>

                          <div
                            className="roul-box-container position-relative"
                            style={{
                              display: activeTabIndex == 1 ? "" : "none"
                            }}
                          >
                            <div
                              className={`flex-fill h-100 w-100 absolute overlayRoulettelock ${
                                stopBetting || oddsData?.evt_status == "CLOSED"
                                  ? ""
                                  : "hides"
                              }`}
                            >
                              <div style={{ textAlign: "center" }}>
                                <svg
                                  focusable="false"
                                  aria-hidden="true"
                                  viewBox="0 0 24 24"
                                  data-testid="LockIcon"
                                  className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium lock-icon css-vubbuv"
                                  style={{ width: "70px", filter: "invert(0)" }}
                                >
                                  <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                                </svg>
                              </div>
                            </div>
                            {/* Chips / Odds / Undo / Reset */}
                            {!isMobile ? (
                              <div className="roul-box-desktop">
                                <div className="chip-odds-view-ctn">
                                  <div className="chip-odds-view-layer">
                                    <div className="t-l-ctn col-3">
                                      <div className="total-bets">
                                        <span className="text">Total Bet</span>
                                        <span className="t-count">0</span>
                                      </div>
                                    </div>

                                    <div className="chipDeck col-6">
                                      <div className="chip-ctn">
                                        <div
                                          id="fadeIn"
                                          className="show-stakes"
                                        >
                                          <div className="chips-layer">
                                            <div
                                              className={`cdChip ${
                                                betAmount === 100
                                                  ? "dream_zoomed_chip Active"
                                                  : "noActive"
                                              }`}
                                              onClick={() => setBetAmount(100)}
                                            >
                                              <img
                                                src={chip1}
                                                alt=""
                                                className="chipimg"
                                              />
                                              <span className="cdChipSpan">
                                                100
                                              </span>
                                            </div>
                                            <div
                                              className={`cdChip ${
                                                betAmount === 200
                                                  ? "dream_zoomed_chip Active"
                                                  : "noActive"
                                              }`}
                                              onClick={() => setBetAmount(200)}
                                            >
                                              <img
                                                src={chip2}
                                                alt=""
                                                className="chipimg"
                                              />
                                              <span className="cdChipSpan">
                                                200
                                              </span>
                                            </div>
                                            <div
                                              className={`cdChip ${
                                                betAmount === 500
                                                  ? "dream_zoomed_chip Active"
                                                  : "noActive"
                                              }`}
                                              onClick={() => setBetAmount(500)}
                                            >
                                              <img
                                                src={chip3}
                                                alt=""
                                                className="chipimg"
                                              />
                                              <span className="cdChipSpan">
                                                500
                                              </span>
                                            </div>
                                            <div
                                              className={`cdChip ${
                                                betAmount === 1000
                                                  ? "dream_zoomed_chip Active"
                                                  : "noActive"
                                              }`}
                                              onClick={() => setBetAmount(1000)}
                                            >
                                              <img
                                                src={chip4}
                                                alt=""
                                                className="chipimg"
                                              />
                                              <span className="cdChipSpan">
                                                1k
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="ure-btn col-3">
                                      <div
                                        className="undo-ctn"
                                        onClick={undoLastBet}
                                      >
                                        <img
                                          src={undoIcon}
                                          alt=""
                                          className="undo-icon"
                                        />
                                        <span>Undo</span>
                                      </div>
                                      <div
                                        className="reset-ctn"
                                        onClick={resetBets}
                                      >
                                        <img
                                          src={resetIcon}
                                          alt=""
                                          className="reset-icon"
                                        />
                                        <span>Reset</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div id="mobileChipOdds">
                                <div className="roul-box-desktop">
                                  <div className="chip-odds-view-ctn">
                                    <div className="chip-odds-view-layer">
                                      <div className="t-l-ctn col-6">
                                        <div className="total-bets">
                                          <span className="text">
                                            Total Bet
                                          </span>
                                          <span className="t-count">0</span>
                                        </div>
                                      </div>
                                      <div className="ure-btn col-6">
                                        <div
                                          className="undo-ctn"
                                          onClick={undoLastBet}
                                        >
                                          <img
                                            src={undoIcon}
                                            alt=""
                                            className="undo-icon"
                                          />
                                          <span>Undo</span>
                                        </div>
                                        <div
                                          className="reset-ctn"
                                          onClick={resetBets}
                                        >
                                          <img
                                            src={resetIcon}
                                            alt=""
                                            className="reset-icon"
                                          />
                                          <span>Reset</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="roul-box-desktop">
                                  <div className="chip-odds-view-ctn">
                                    <div className="chip-odds-view-layer">
                                      <div className="chipDeck col-12">
                                        <div className="chip-ctn">
                                          <div
                                            id="fadeIn"
                                            className="show-stakes"
                                          >
                                            <div className="chips-layer">
                                              <div
                                                className={`cdChip ${
                                                  betAmount === 100
                                                    ? "dream_zoomed_chip Active"
                                                    : "noActive"
                                                }`}
                                                onClick={() =>
                                                  setBetAmount(100)
                                                }
                                              >
                                                <img
                                                  src={chip1}
                                                  alt=""
                                                  className="chipimg"
                                                />
                                                <span className="cdChipSpan">
                                                  100
                                                </span>
                                              </div>
                                              <div
                                                className={`cdChip ${
                                                  betAmount === 200
                                                    ? "dream_zoomed_chip Active"
                                                    : "noActive"
                                                }`}
                                                onClick={() =>
                                                  setBetAmount(200)
                                                }
                                              >
                                                <img
                                                  src={chip2}
                                                  alt=""
                                                  className="chipimg"
                                                />
                                                <span className="cdChipSpan">
                                                  200
                                                </span>
                                              </div>
                                              <div
                                                className={`cdChip ${
                                                  betAmount === 500
                                                    ? "dream_zoomed_chip Active"
                                                    : "noActive"
                                                }`}
                                                onClick={() =>
                                                  setBetAmount(500)
                                                }
                                              >
                                                <img
                                                  src={chip3}
                                                  alt=""
                                                  className="chipimg"
                                                />
                                                <span className="cdChipSpan">
                                                  500
                                                </span>
                                              </div>
                                              <div
                                                className={`cdChip ${
                                                  betAmount === 1000
                                                    ? "dream_zoomed_chip Active"
                                                    : "noActive"
                                                }`}
                                                onClick={() =>
                                                  setBetAmount(1000)
                                                }
                                              >
                                                <img
                                                  src={chip4}
                                                  alt=""
                                                  className="chipimg"
                                                />
                                                <span className="cdChipSpan">
                                                  1k
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="roul-box-desktop">
                              <div className="custom-container">
                                <div className="custom-grid custom-grid-cols-3 custom-gap-4">
                                  <div
                                    className="custom-card custom-card-yellow"
                                    onClick={() => addToBet("b1")}
                                  >
                                    <span className="dream_chips_cls">
                                      {b1Amt}
                                    </span>
                                    <span className="custom-card-number">
                                      {parseInt(oddsData?.b1) ||
                                        DC_MULTIPLIERS.b1}
                                    </span>{" "}
                                    <div className="custom-card-diamond custom-card-diamond-left" />{" "}
                                    <div className="custom-card-diamond custom-card-diamond-right" />{" "}
                                    <span className="custom-card-payout">
                                      PAYS{" "}
                                      {parseInt(oddsData?.b1) ||
                                        DC_MULTIPLIERS.b1}
                                      x
                                    </span>{" "}
                                    {/**/}{" "}
                                    <span className="zero-value">{/**/}</span>
                                  </div>{" "}
                                  <div
                                    className="custom-card custom-card-blue"
                                    onClick={() => addToBet("b2")}
                                  >
                                    <span className="dream_chips_cls">
                                      {b2Amt}
                                    </span>
                                    <span className="custom-card-number">
                                      {parseInt(oddsData?.b2) ||
                                        DC_MULTIPLIERS.b2}
                                    </span>{" "}
                                    <div className="custom-card-diamond custom-card-diamond-left" />{" "}
                                    <div className="custom-card-diamond custom-card-diamond-right" />{" "}
                                    <span className="custom-card-payout">
                                      PAYS{" "}
                                      {parseInt(oddsData?.b2) ||
                                        DC_MULTIPLIERS.b2}
                                      x
                                    </span>{" "}
                                    {/**/}{" "}
                                    <span className="zero-value">{/**/}</span>
                                  </div>{" "}
                                  <div
                                    className="custom-card custom-card-purple"
                                    onClick={() => addToBet("b3")}
                                  >
                                    <span className="dream_chips_cls">
                                      {b3Amt}
                                    </span>
                                    <span className="custom-card-number">
                                      {parseInt(oddsData?.b3) ||
                                        DC_MULTIPLIERS.b3}
                                    </span>{" "}
                                    <div className="custom-card-diamond custom-card-diamond-left" />{" "}
                                    <div className="custom-card-diamond custom-card-diamond-right" />{" "}
                                    <span className="custom-card-payout">
                                      PAYS{" "}
                                      {parseInt(oddsData?.b3) ||
                                        DC_MULTIPLIERS.b3}
                                      x
                                    </span>{" "}
                                    {/**/}{" "}
                                    <span className="zero-value">{/**/}</span>
                                  </div>{" "}
                                  <div
                                    className="custom-card custom-card-green"
                                    onClick={() => addToBet("b4")}
                                  >
                                    <span className="dream_chips_cls">
                                      {b4Amt}
                                    </span>
                                    <span className="custom-card-number">
                                      {parseInt(oddsData?.b4) ||
                                        DC_MULTIPLIERS.b4}
                                    </span>{" "}
                                    <div className="custom-card-diamond custom-card-diamond-left" />{" "}
                                    <div className="custom-card-diamond custom-card-diamond-right" />{" "}
                                    <span className="custom-card-payout">
                                      PAYS{" "}
                                      {parseInt(oddsData?.b4) ||
                                        DC_MULTIPLIERS.b4}
                                      x
                                    </span>{" "}
                                    {/**/}{" "}
                                    <span className="zero-value">{/**/}</span>
                                  </div>{" "}
                                  <div
                                    className="custom-card custom-card-orange"
                                    onClick={() => addToBet("b5")}
                                  >
                                    <span className="dream_chips_cls">
                                      {b5Amt}
                                    </span>
                                    <span className="custom-card-number">
                                      {parseInt(oddsData?.b5) ||
                                        DC_MULTIPLIERS.b5}
                                    </span>{" "}
                                    <div className="custom-card-diamond custom-card-diamond-left" />{" "}
                                    <div className="custom-card-diamond custom-card-diamond-right" />{" "}
                                    <span className="custom-card-payout">
                                      PAYS{" "}
                                      {parseInt(oddsData?.b5) ||
                                        DC_MULTIPLIERS.b5}
                                      x
                                    </span>{" "}
                                    {/**/}{" "}
                                    <span className="zero-value">{/**/}</span>
                                  </div>{" "}
                                  <div
                                    className="custom-card custom-card-pink"
                                    onClick={() => addToBet("b6")}
                                  >
                                    <span className="dream_chips_cls">
                                      {b6Amt}
                                    </span>
                                    <span className="custom-card-number">
                                      {parseInt(oddsData?.b6) ||
                                        DC_MULTIPLIERS.b6}
                                    </span>{" "}
                                    <div className="custom-card-diamond custom-card-diamond-left" />{" "}
                                    <div className="custom-card-diamond custom-card-diamond-right" />{" "}
                                    <span className="custom-card-payout">
                                      PAYS{" "}
                                      {parseInt(oddsData?.b6) ||
                                        DC_MULTIPLIERS.b6}
                                      x
                                    </span>{" "}
                                    {/**/}{" "}
                                    <span className="zero-value">{/**/}</span>
                                  </div>
                                </div>{" "}
                                {/**/}
                              </div>
                            </div>
                          </div>
                          <div
                            style={{
                              display: activeTabIndex == 2 ? "" : "none",
                              color: "white"
                            }}
                          >
                            <DreamCatcherResult resultData={resultData} />
                          </div>
                        </div>
                        {/* END LEFT COLUMN */}

                        {/* RIGHT COLUMN */}
                        <div className="col-lg-4 no-padding-mobile">
                          <div className="right-content">
                            <div>
                              <div className="table-box-body">
                                {/* Mobile Modal (kept intact) */}
                                <div
                                  id="betSlipMobile"
                                  tabIndex="-1"
                                  role="dialog"
                                  aria-labelledby="fancyPosition"
                                  aria-hidden="true"
                                  className="modal fade"
                                >
                                  <div
                                    role="document"
                                    className="modal-dialog modal-md"
                                  >
                                    <div className="modal-content back">
                                      <div className="modal-body">
                                        <table>
                                          <tbody>
                                            <tr>
                                              <td>{"\u00A0"}</td>
                                              <th colSpan="3"></th>
                                            </tr>
                                            <tr>
                                              <td>ODDS</td>
                                              <td colSpan="2">
                                                <div className="input-group mt-2">
                                                  <div className="input-group-prepend">
                                                    <button
                                                      type="button"
                                                      className="btn btn-outline-secondary"
                                                    >
                                                      <strong>-</strong>
                                                    </button>
                                                  </div>
                                                  <input
                                                    type="number"
                                                    id="bet-price"
                                                    step="0.01"
                                                    min="1.01"
                                                    max="1000"
                                                    className="form-control"
                                                  />
                                                  <div className="input-group-append">
                                                    <button
                                                      type="button"
                                                      className="btn btn-outline-secondary"
                                                    >
                                                      <strong>+</strong>
                                                    </button>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Amount</td>
                                              <td colSpan="2">
                                                <input
                                                  type="number"
                                                  id="bet-size-m"
                                                  className="form-control mt-2"
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <td style={{ width: "25%" }}>
                                                <button
                                                  type="button"
                                                  data-amount="10000"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  10,000
                                                </button>
                                              </td>
                                              <td style={{ width: "25%" }}>
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  250,000
                                                </button>
                                              </td>
                                              <td style={{ width: "25%" }}>
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  50,000
                                                </button>
                                              </td>
                                              <td style={{ width: "25%" }}>
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  100,000
                                                </button>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  +100,000
                                                </button>
                                              </td>
                                              <td>
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  +250,000
                                                </button>
                                              </td>
                                              <td>
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  +500,000
                                                </button>
                                              </td>
                                              <td>
                                                <button
                                                  type="button"
                                                  className="btn btn-secondary btn-block mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  +1,000,000
                                                </button>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <button
                                                  type="button"
                                                  data-dismiss="modal"
                                                  className="btn btn-danger mt-2"
                                                  style={{
                                                    touchAction: "manipulation"
                                                  }}
                                                >
                                                  Close
                                                </button>
                                              </td>
                                              <td colSpan="2">
                                                <div
                                                  className="btn btn-primary ld-over mt-2"
                                                  style={{ cursor: "pointer" }}
                                                >
                                                  <b>Submit</b>
                                                  <div className="ld ld-ball ld-flip"></div>
                                                </div>{" "}
                                                <span> / -</span>
                                              </td>
                                            </tr>
                                            <tr style={{ display: "none" }}>
                                              <td
                                                colSpan="4"
                                                className="alert-danger pr-5"
                                              ></td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* /Modal */}

                                {/* Matched Bets */}
                                <div>
                                  <div className="bets">
                                    <strong>
                                      Matched Bets (0)
                                      <img
                                        src={reconnecting}
                                        alt="dc"
                                        className="rounded disconnected"
                                        style={{ display: "none" }}
                                      />{" "}
                                    </strong>
                                    <div className="betting-table">
                                      <table className="table">
                                        <thead>
                                          <tr>
                                            <th>Runner</th>
                                            <th>Price</th>
                                            <th>Size</th>
                                            <th></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {placedBets.map((bet, index) => (
                                            <tr key={index}>
                                              <td>
                                                {displayRunnerName(bet.rnr)}
                                              </td>
                                              <td>{bet.amnt}</td>
                                              <td>{bet.rate}</td>
                                              <td></td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                {/* /Matched Bets */}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* END RIGHT COLUMN */}
                      </div>
                      {/* /row w-100 */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ClientLayoutWithOutHeader>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        closeButton={false}
        newestOnTop
        limit={3}
      />
      <style>
        {`
          .av-bet-toast,
          .av-lost-toast {
            border-radius: 8px !important;
            padding: 12px 20px !important;
            min-height: unset !important;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.38) !important;
            overflow: hidden;
          }
          .av-bet-toast {
            background: #43a047 !important;
          }
          .av-lost-toast {
            background: #c62828 !important;
          }
          .av-bet-toast .Toastify__toast-body,
          .av-lost-toast .Toastify__toast-body {
            padding: 0 !important;
            margin: 0 !important;
          }
          .av-bet-toast .Toastify__progress-bar,
          .av-lost-toast .Toastify__progress-bar {
            background: rgba(0, 0, 0, 0.2) !important;
            height: 4px;
          }
          .av-toast-body {
            display: flex;
            align-items: center;
            gap: 12px;
            color: #ffffff;
            font-size: 18px;
            font-weight: 600;
            line-height: 1.2;
            white-space: nowrap;
          }
          .av-toast-icon {
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
          }
          .av-toast-icon svg {
            display: block;
            width: 24px;
            height: 24px;
          }
          .av-toast-text {
            padding-top: 1px;
          }
        `}
      </style>
    </>
  );
}
